import { render } from "./uiBadge.vue?vue&type=template&id=27d29cfa&scoped=true"
import script from "./uiBadge.vue?vue&type=script&lang=js"
export * from "./uiBadge.vue?vue&type=script&lang=js"

import "./uiBadge.vue?vue&type=style&index=0&id=27d29cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d29cfa"]])

export default __exports__